export const getTrademarkVerificationContent = () => ({
  metaTitle: 'verification-meta-title',
  metaDescription: 'verification-meta-desc',
})
